import { render, staticRenderFns } from "./TravelPlanningSustainableTravel.vue?vue&type=template&id=bc13143a&"
import script from "./TravelPlanningSustainableTravel.vue?vue&type=script&lang=ts&"
export * from "./TravelPlanningSustainableTravel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports